const members = [
  {
    "membershipId": 1619399,
    "name": "Abhimaan Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619400,
    "name": "Abishek Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619401,
    "name": "Aditya Ashish",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619402,
    "name": "Adtya Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619403,
    "name": "Aditya Singh",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619404,
    "name": "Aditya Singh Chandel",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619405,
    "name": "Akash Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619406,
    "name": "Aman Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619407,
    "name": "Aman Yadav",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619408,
    "name": "Amit Kumar Gautam",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619409,
    "name": "Anshuman Samanta",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619410,
    "name": "Ayesha Gupta",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619411,
    "name": "Ayush Nagar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619412,
    "name": "Baibhav Kumar Chandra",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619413,
    "name": "Bhanu Shankar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619414,
    "name": "Challa Manikanta",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619415,
    "name": "Divyanshu Raj Harsh",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619416,
    "name": "Dumani Murmu",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619417,
    "name": "Karan Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619418,
    "name": "Krish Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619419,
    "name": "Kumar Aryan",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619420,
    "name": "Manshi Vatsa",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619421,
    "name": "Mansi Kumari",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619422,
    "name": "Mayank Suman",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619423,
    "name": "Md Tarik Anvar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619424,
    "name": "Md Reyaz Haider",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619425,
    "name": "Monalisha Anand",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619426,
    "name": "Nayan Jyoti",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619427,
    "name": "Nishan Das",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619428,
    "name": "Om Vishesh",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619429,
    "name": "Pawan Chaudhary",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619430,
    "name": "Priyanshu Verma",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619431,
    "name": "Raj Aryan",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619432,
    "name": "Rajshree",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619433,
    "name": "Ravinandan Samrat",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619434,
    "name": "Raya",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619435,
    "name": "Ritu Kumari",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619436,
    "name": "Sahil Singh",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619437,
    "name": "Saket Tripathi",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619438,
    "name": "Saksham Singh",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619439,
    "name": "Sandeep Mahato",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619440,
    "name": "Saurabh Prasad",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619441,
    "name": "Shradha Singh",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619442,
    "name": "Shubham Raj",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619443,
    "name": "Soumya Ranjan Nayak",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619444,
    "name": "Vidit Mishra",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619445,
    "name": "Vishesh Singh",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619446,
    "name": "Avinash Jaiswal",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619447,
    "name": "Neha Kumari",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619448,
    "name": "Saket Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619449,
    "name": "Sushovan Sarkar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619450,
    "name": "Sachin Kumar Yadav",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619451,
    "name": "Manas Mani",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619452,
    "name": "Ashish Sahu",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619453,
    "name": "Abhishek",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619454,
    "name": "Abhishek Hansdak",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619455,
    "name": "Aditya Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619456,
    "name": "Akash Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619457,
    "name": "Akhilesh Yadav",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619458,
    "name": "Amit Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619459,
    "name": "Amit Mandal",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619460,
    "name": "Amrita Kumari",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619461,
    "name": "Anand Choudhary",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619462,
    "name": "Anish Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619463,
    "name": "Ankit Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619464,
    "name": "Ankit Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619465,
    "name": "Anushka Anand",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619466,
    "name": "Apurba Das",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619467,
    "name": "Ayan Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619468,
    "name": "Ayush Dutt Pathak",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619469,
    "name": "Ayush Raj",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619470,
    "name": "Basil Joy",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619471,
    "name": "Dhiraj Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619472,
    "name": "Disha Basu Roy Chowdhury",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619473,
    "name": "Diwakar Singh",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619474,
    "name": "Gyanendra Verma",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619475,
    "name": "Hemant Prakash",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619476,
    "name": "Himani Kumari",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619477,
    "name": "Himanshu",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619478,
    "name": "Himanshu Shekhar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619479,
    "name": "Kamlesh Yadav",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619480,
    "name": "Keerti Lata Choudhury",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619481,
    "name": "Khushi Chourase",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619482,
    "name": "Khushi Kumari",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619483,
    "name": "Kunal Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619484,
    "name": "Md Arif Ansari",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619485,
    "name": "Mitthu Kumar",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619486,
    "name": "Mobashir Ashraf",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619487,
    "name": "Munukutla Sri Shanmukha Aditya",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619488,
    "name": "Namrata Dey",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619489,
    "name": "Nisha Kumari",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619490,
    "name": "Prashant Dubey",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619491,
    "name": "Priyanka Kumari Raj",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619492,
    "name": "Priyanshu Raj",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619493,
    "name": "Rishav Mishra",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619494,
    "name": "Rodasi Bera",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619495,
    "name": "Srishti Pathak",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619496,
    "name": "Shubham Maurya",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619497,
    "name": "Siya Mandal",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619498,
    "name": "Sneha Priya",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619499,
    "name": "Sushanta Mahato",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619500,
    "name": "Ujit Raj Rathore",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619501,
    "name": "Vaishnavi Sharma",
    "branch": "Computer Science Engineering"
  },
  {
    "membershipId": 1619502,
    "name": "Vishal Kumar Singh",
    "branch": "Computer Science Engineering"
  }
];

export default members;
